// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-trigger_root__F6v0_","trigger":"accordion-trigger_trigger__RTtwH","icon":"accordion-trigger_icon__yzPpx"};